var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 35.672 35.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12212",
    "data-name": "Group 12212",
    transform: "translate(-3264.081 504.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41534",
    "data-name": "Path 41534",
    d: "M3380.284-382.727h-7.361v-23.765h7.04v3.2c.1-.055.145-.066.162-.094a7.68,7.68,0,0,1,6.744-3.7,10.219,10.219,0,0,1,4.749.859,6.842,6.842,0,0,1,3.642,4.531,17.3,17.3,0,0,1,.658,4.9c.031,4.584.019,9.169.023,13.754,0,.07-.01.14-.017.238h-7.382v-.493c0-3.888.01-7.776-.015-11.665a15.141,15.141,0,0,0-.235-2.637c-.449-2.434-2.033-3.261-4.3-2.993-2.065.244-3.2,1.452-3.523,3.687a18,18,0,0,0-.174,2.47c-.018,3.714-.008,7.428-.008,11.142Z",
    transform: "translate(-96.187 -85.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41535",
    "data-name": "Path 41535",
    d: "M3269.347-402.013h7.353v23.755h-7.353Z",
    transform: "translate(-4.654 -90.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41536",
    "data-name": "Path 41536",
    d: "M3272.638-499.916a4.314,4.314,0,0,1-4.244,4.337,4.337,4.337,0,0,1-4.313-4.32,4.31,4.31,0,0,1,4.253-4.283A4.283,4.283,0,0,1,3272.638-499.916Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fa77bcddc534a5efdd3225109affed5c.svg";
export { ForwardRef as ReactComponent };